import Vue from 'vue'

import FooterNav from './components/FooterNav.vue'
import PrimaryNav from './components/PrimaryNav.vue'

Vue.prototype.$theme = 'showroom'

Vue.component('PrimaryNav', PrimaryNav)
Vue.component('FooterNav', FooterNav)
